import { useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PrerenderData } from "@/seo/PrerenderContext";

export const useUpcomingEvents = () => {
  const pre = useContext(PrerenderData);
  const [events, setEvents] = useState(pre?.events || []);
  const [loading, setLoading] = useState(!pre);

  useEffect(() => {
    if (pre) return undefined;
    let cancelled = false;
    api
      .get("/events")
      .then(({ data }) => !cancelled && setEvents(data.events || []))
      .catch(() => !cancelled && setEvents([]))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [pre]);

  return { events, loading };
};
